<div class="d-flex justify-content-between p_l-8 p_r-7 m_b-4">
  <div class="body_text large_text semi_bold">Stores (0)</div>
  <div>Show Receipts</div>
</div>
<div class="d-flex">
  <kkm-store-list [taxpayer]="taxpayer"></kkm-store-list>
</div>
